import React from 'react';
import styled from 'styled-components';
import amex from '../../images/icon/amex.svg';
import mastercard from '../../images/icon/mastercard.svg';
import paypal from '../../images/icon/paypal.svg';
import visa from '../../images/icon/visa.svg';

const Methods = styled.div`
	text-align: center;
	margin: 0 auto;
`;
const ImgCard = styled.img`
	width: 30px;
	margin: 0 4px;
`;
const Notice = styled.p`
	margin: ${props => props.theme.vr * 0.2}rem 0 0;
	font-size: 12px;
	color: rgba(84, 94, 111, 0.3);
`;

export default () => (
	<Methods>
		<ImgCard src={visa} alt="VISA" />
		<ImgCard src={paypal} alt="PayPal" />
		<ImgCard src={amex} alt="Amex" />
		<ImgCard src={mastercard} alt="MasterCard" />
		<Notice>Price excludes VAT/GST</Notice>
	</Methods>
);
